import React, { CSSProperties, FC } from 'react';
import { EstimatedTotalTripMode, Load } from '../../../../../types';
import { orderToLoadingDurationMinutes } from '../../../../../utils/data-mapping-utils';
import { useTravelTimesLoad } from '../../../../travel-times/use-travel-times';
import { getDuration } from '../../../../../utils/date-time-utils';
import { CircularProgress } from '@mui/material';
import { AgisticsTooltip } from '../../../../shared/agistics-tooltip';
import { NoMUITravelTimeTooltip } from '../../../../travel-times/travel-time-tooltip';
import { getConvertedDistance } from '../../../../../utils/distance-utils';

interface EstimatedTotalTripProps {
    mode?: EstimatedTotalTripMode;
    load: Load;
    style?: CSSProperties;
}

export const EstimatedTotalTrip: FC<EstimatedTotalTripProps> = (props) => {
    const { mode, load, style } = props;
    const appliedMode = mode || 'time';
    const loadDurationMinutes = orderToLoadingDurationMinutes(load);
    const { travelTime, travelDistance, isLoading } = useTravelTimesLoad(load);
    const minuteMs = 1000 * 60;
    const roundedTotalTripMs = Math.ceil((travelTime + loadDurationMinutes) / 5) * 5 * minuteMs; // move to next 5 minute interval
    const durationText = roundedTotalTripMs > 0 ? getDuration(roundedTotalTripMs) : '';
    const { convertedDistance, abbreviation } = getConvertedDistance(travelDistance);
    const convertedDistanceRound = convertedDistance ? Math.round(parseFloat(convertedDistance)) : 0;

    return (
        <div style={style}>
            {isLoading
                ? <CircularProgress size='1em' />
                : <AgisticsTooltip
                        tooltip={
                            <NoMUITravelTimeTooltip
                                loadDurationMinutes={loadDurationMinutes}
                                travelTimeMinutes={travelTime}
                                durationText={durationText}
                                travelDistance={travelDistance}
                            />
                        }
                    >
                        {appliedMode === 'time' ? durationText : `${convertedDistanceRound} ${abbreviation}`}
                    </AgisticsTooltip>
            }
        </div>
    );
};
